var contains = $('.contains');

$('html').click(function() {
    //Hide the menus if visible
    $('.pricing-show').removeClass('pricing-show');
    $('.sidebar').removeClass('sidebar-show');
    $('.hamburger').removeClass('menu-close');
    $('.user_caret').removeClass('caret_active');
    $('.user_dropdown > ul').removeClass('nav-active');
    //$(".vis-header-search").slideUp(500);
});
$('.sidebar').click(function(event) {
    event.stopPropagation();
});
$('.user_dropdown').click(function(event){
    event.stopPropagation();
    $('.user_dropdown > ul').toggleClass('nav-active');
    $('.user_caret').toggleClass('caret_active');
});
$('.prevent-def').on('click touchstart touchend touchmove tap dbltap dragstart dragmove dragend', function (event) {
    event.stopPropagation();
});

$('.select-img').click(function(){
    $('.select-img img').removeClass('selected-img');
    $(this).find('img').toggleClass('selected-img');
    var avValue = $(this).attr('data-value');
    console.log(avValue);
    $('.avatar-value').val(avValue);
});
$('.select-main-img').click(function(){
    $('.select-main-img img').removeClass('selected-main-img');
    $(this).find('img').toggleClass('selected-main-img');
    var mainImgValue = $(this).attr('data-value');
    $('.main-img-value').val(mainImgValue);
});


$( document ).on( 'keydown', function ( e ) {
    if ( e.keyCode === 27 ) { // ESC

    }
});
document.addEventListener("DOMContentLoaded", function() {
    var lazyloadImages;

    if ("IntersectionObserver" in window) {
        lazyloadImages = document.querySelectorAll(".lazy");
        var imageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var image = entry.target;
                    image.classList.remove("lazy");
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyloadImages.forEach(function(image) {
            imageObserver.observe(image);
        });
    } else {
        var lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(".lazy");

        function lazyload () {
            if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(function() {
                var scrollTop = window.pageYOffset;
                lazyloadImages.forEach(function(img) {
                    if(img.offsetTop < (window.innerHeight + scrollTop)) {
                        img.src = img.dataset.src;
                        img.classList.remove('lazy');
                    }
                });
                if(lazyloadImages.length == 0) {
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }

        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    }
});


//   all ------------------
function initCitybook() {
    "use strict";
    //   loader ------------------
    $(".loader-wrap").fadeOut(300, function () {
        $("#main").animate({
            opacity: "1"
        }, 300);
    });

    function showShare() {
        shrcn.removeClass("isShare");
        shrcn.addClass("visshare");
    }
    function hideShare() {
        shrcn.addClass("isShare");
        shrcn.removeClass("visshare");
    }
    $(".showshare").on("click", function () {
        $(this).toggleClass("vis-butsh");
        $(this).find("span").text($(this).text() === 'Close' ? 'Share' : 'Close');
        if ($(".share-container").hasClass("isShare")) showShare();
        else hideShare();
    });


    //   tabs------------------
    $(".tabs-menu a").on("click", function (a) {
        a.preventDefault();
        $(this).parent().addClass("current");
        $(this).parent().siblings().removeClass("current");
        var b = $(this).attr("href");
        $(".tab-content").not(b).css("display", "none");
        $(b).fadeIn();
    });
    // click ------------------
    $(".more-filter-option").on("click", function () {
        $(".hidden-listing-filter").slideToggle(500);
        $(this).find("span").toggleClass("mfilopact");
    });
    // $(".vis-header-search").on("click", function (e) {
    //     e.stopPropagation();
    // });
    $(".show-search-button").on("click", function (e) {
        e.stopPropagation();
        $(".vis-header-search").slideToggle(500);
    });
    $(".listing-view-layout li a.list").on("click", function (e) {
        e.preventDefault();
        $(".listing-view-layout li a").removeClass("active");
        $(".listing-item").addClass("list-layout");
        $(this).addClass("active");
    });
    $(".listing-view-layout li a.grid").on("click", function (e) {
        e.preventDefault();
        $(".listing-view-layout li a").removeClass("active");
        $(".listing-item").removeClass("list-layout");
        $(this).addClass("active");
    });
    // Forms ------------------
    $(document).on('change', '.leave-rating input', function() {
        var $radio = $(this);
        $('.leave-rating .selected').removeClass('selected');
        $radio.closest('label').addClass('selected');
    });


    // Mob Menu------------------
    $('.nav-button-wrap .hamburger').click(function(event){
        $('.sidebar').toggleClass('sidebar-show');
        $(this).toggleClass('menu-close');
        event.stopPropagation();
    });

    $('.sidebar').click(function(event) {
        event.stopPropagation();
    });

    $('html').click(function() {
        //Hide the menus if visible
        $('.sidebar').removeClass('sidebar-show');
        $('.hamburger').removeClass('menu-close');
        $('.hamburger').removeClass('menu-close');
    });

    $(".header-user-name").on("click", function () {
        $(".header-user-menu ul").toggleClass("hu-menu-vis");
        $(this).toggleClass("hu-menu-visdec");
    });

}

document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
});

//   Init All ------------------
$(function () {
    initCitybook();
});
